var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router-dom';
import { fetchPreMatchMenu as fetchPreMatchMenuAction } from '../../actions/creators/lines';
import { setDisplayMode as setDisplayModeAction } from '../../actions/creators/displayMode';
import { setActiveTab as setActiveTabAction } from '../../actions/creators/sidebar';
import { sportSortFunc } from '../../rendering-commons/Sorting';
import * as TimeFilter from '../../constants/TimeFilter';
import * as DisplayMode from '../../constants/DisplayMode';
import MenuTabs from './MenuTabs';
import Carousel from './Carousel';
import SliderBanner from '../slider-banner';
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedSportId: undefined
        };
        _this.tabClick = function (tab) {
            if (tab === 'sport' && _this.state.selectedSportId !== undefined && _this.props.preMatchFetching === false) {
                if (_this.state.selectedSportId === '/timetable') {
                    _this.setState({
                        selectedSportId: undefined
                    });
                    _this.props.history.replace('/' + tab);
                }
                else {
                    _this.props.history.replace('/' + tab + '/' + _this.state.selectedSportId);
                }
            }
            else if (tab === 'main-live') {
                _this.props.history.replace('/');
                _this.props.setActiveTabAction('live');
            }
            else {
                if (!_this.props.preMatchFetching) {
                    _this.props.history.replace('/' + tab);
                    _this.props.setActiveTabAction(tab);
                }
            }
        };
        _this.allMatchesClick = function () {
            _this.props.push('/sport');
            _this.props.setActiveTabAction('sport');
            _this.setState({
                selectedSportId: undefined
            });
        };
        _this.preMatchSportClick = function (link) {
            if (link === '/timetable') {
                _this.props.setDisplayModeAction({});
                _this.props.push(link);
            }
            else {
                _this.props.push("/sport/".concat(link));
            }
            _this.setState({
                selectedSportId: link
            });
        };
        _this.liveSportClick = function (id) {
            var type = id === 'all' ? DisplayMode.ALL : DisplayMode.SPORT;
            _this.props.setDisplayModeAction({ type: type, id: id });
            _this.props.push('/live');
        };
        _this.topEventsClick = function () {
            _this.props.push('/');
        };
        _this.bundesligaBannerClick = function () {
            _this.props.push("/sport/7/9042903");
        };
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        if (window.location.href.indexOf('live') > -1) {
        }
        else {
            this.props.fetchPreMatchMenuAction({ languageId: this.props.languageId, filterType: TimeFilter.ALL });
        }
    };
    Menu.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.languageId !== nextProps.languageId) {
            this.props.fetchPreMatchMenuAction({ languageId: nextProps.languageId, filterType: TimeFilter.ALL });
        }
        if (nextProps.activeTab !== this.props.activeTab && nextProps.activeTab === 'sport') {
            this.props.fetchPreMatchMenuAction({ languageId: nextProps.languageId, filterType: TimeFilter.ALL });
        }
    };
    Menu.prototype.render = function () {
        var _a = this.props, sports = _a.sports, pathname = _a.pathname, fetching = _a.fetching, displayMode = _a.displayMode, auth = _a.auth, client = _a.client, languageId = _a.languageId;
        var selectedSportId = this.state.selectedSportId;
        var carouselProps = {
            preMatchSportClick: this.preMatchSportClick,
            liveSportClick: this.liveSportClick,
            sports: sports,
            auth: auth,
            countryCode: client.country,
            topEventsClick: this.topEventsClick,
            tabClick: this.tabClick,
            allMatchesClick: this.allMatchesClick,
            pathname: pathname,
            fetching: fetching,
            displayMode: displayMode,
            selectedSportId: selectedSportId,
            activeTab: this.props.activeTab
        };
        var showCarousel = true;
        if (window.location.pathname.includes('games'))
            showCarousel = false;
        if (window.location.pathname.includes('cybersport'))
            showCarousel = false;
        return (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ id: 'mainmenu' }, { children: [_jsx(MenuTabs, { activeTab: this.props.activeTab, user: auth.user, countryCode: client.country, tabClick: this.tabClick, languageId: languageId }), showCarousel && (_jsx("div", __assign({ className: 'tab-content' }, { children: _jsx("div", __assign({ className: 'tab-pane active' }, { children: _jsx(Carousel, __assign({}, carouselProps)) })) })))] })), _jsx(SliderBanner, {})] }));
    };
    return Menu;
}(React.Component));
Menu.propTypes = {
    auth: PropTypes.object.isRequired,
    fetchPreMatchMenuAction: PropTypes.func.isRequired,
    setDisplayModeAction: PropTypes.func.isRequired,
    setActiveTabAction: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    pathname: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired,
    languageId: PropTypes.number.isRequired,
    push: PropTypes.func.isRequired,
    displayMode: PropTypes.object.isRequired,
};
var mapStateToProps = function (state) {
    var sports = state.application.get('activeTab') === 'live' ?
        state.application.getIn(['live', 'sports']).filter(function (s) { return s.get('leagues').size > 0; }).sort(sportSortFunc) :
        state.application.getIn(['menu', 'sports']).filter(function (s) { return s.get('leagues').size > 0; }).sort(sportSortFunc);
    return {
        pathname: state.routing.location.pathname,
        languageId: state.application.get('languageId'),
        sports: sports,
        fetching: state.application.getIn(['menu', 'menuFetching']),
        preMatchFetching: state.application.getIn(['preMatch', 'fetching']),
        displayMode: state.application.get('displayMode'),
        auth: state.auth,
        client: state.application.get('client'),
    };
};
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    push: push,
    fetchPreMatchMenuAction: fetchPreMatchMenuAction,
    setDisplayModeAction: setDisplayModeAction,
    setActiveTabAction: setActiveTabAction,
}, dispatch); };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));



// WEBPACK FOOTER //
// ./src/components/menu/index.js